import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RedirectUriGuard implements CanActivate {
  constructor(
    public router: Router,
  ) {
  }

  canActivate() {
    window.location.replace(environment.howToChargeLink);
    return false; // block the original route
  }
}
